import { FC, CSSProperties } from 'react';

type EditIconProps = {
  style?: CSSProperties;
  className?: string;
};

const EditPencilIcon: FC<EditIconProps> = ({ style, className }) => {
  return (
    <svg
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={ style }
      className={ className }
    >
      <path
        // eslint-disable-next-line max-len
        d="M11.3207 1.7569L14.7433 5.17957M1.93067 11.1462L5.35667 14.5662M15.0433 1.4569C14.8162 1.23077 14.5466 1.05188 14.25 0.930557C13.9533 0.809234 13.6356 0.747886 13.3151 0.750056C12.9947 0.752225 12.6778 0.81787 12.3828 0.943197C12.0879 1.06852 11.8207 1.25105 11.5967 1.48023L1.93 11.1469L0.75 15.7502L5.35333 14.5696L15.02 4.9029C15.2492 4.67899 15.4318 4.41186 15.5572 4.11695C15.6826 3.82204 15.7482 3.50521 15.7504 3.18477C15.7526 2.86432 15.6912 2.54663 15.5698 2.25005C15.4485 1.95347 15.2695 1.68389 15.0433 1.4569Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default EditPencilIcon;
